import React, { useState, useEffect } from "react";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { ServicioTitles as titles } from "consts/titulos-de-tablas";
import styles from "styles/pages/Pages.module.scss";
import { useService } from "components/route/ServiceRoute";
import XGrid from "components/UI/Grid/XGrid";
import { RNHServicioGet } from "services/services-mia/RNHServicioGet";

export default function ServiciosSalud() {
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);
    const [modalDetails, setModalDetails] = useState({ isOpen: false });
    const [loading, setLoading] = useState(false);
    const [servicios, setServicios] = useState([]);
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const { service } = useService();

    const getServicio = async () => {
        setServicios([]);
        setLoading(true);
        const result = await RNHServicioGet(credentials);
        const newRows = result[0]?.rnhServicioId ? result?.map((data) => {
            return {
                id: data.rnhServicioId,
                cod: data.rnhServicioCod,
                name: data.rnhServicioNombre,
                desc: data.rnhServicioDescripcion,
            };
        }) : []
        setServicios(newRows);
        setLoading(false);
    }
    const closeModal = () => {
        setModalDetails({ isOpen: false });
    };
    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };

    useEffect(() => {
        getServicio()
    }, [])
    useEffect(() => {
        setRoute({
            wordKey: `Servicios - Programa Salud RN`
        })
    }, [service.servicioNombre, setRoute])

    return (
        <main className={styles.main}>
            <Modal open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <UpdateModal
                        user={rowSelected.row}
                        updateList={getServicio}
                        closeModal={closeModal}
                    />
                )}
                {modalDetails.procede === ACTIONS.EXPORT && (
                    <DeleteModal
                        user={rowSelected.row}
                        servicio={service}
                        updateList={getServicio}
                        closeModal={closeModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
                {modalDetails.procede === ACTIONS.INSERT && (
                    <InsertModal
                        servicio={service}
                        updateList={getServicio}
                        closeModal={closeModal}
                    />
                )}
            </Modal>
            <div className={styles["filters-actions-right"]}>
                <Buttons>
                    <HeaderButton
                        text={"Actualizar"}
                        onClick={() => { getServicio() }}
                        disabled={rowSelected.row.id || false}
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text={"Nuevo servicio"}
                        handleClick={handleClick}
                        data={{
                            title: "Nuevo servicio",
                            procede: ACTIONS.INSERT
                        }}
                        disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        text={"Modificar servicio"}
                        handleClick={handleClick}
                        data={{
                            title: "Modificar servicio",
                            procede: ACTIONS.UPDATE
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <EditOutlined />
                    </HeaderButton>
                    <HeaderButton
                        text={"Eliminar servicio"}
                        handleClick={handleClick}
                        data={{
                            title: "Eliminar servicio",
                            procede: ACTIONS.EXPORT
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <DeleteOutlineRoundedIcon />
                    </HeaderButton>
                </Buttons>
            </div>
            <div className={styles.container}>
                <XGrid
                    rows={servicios}
                    titles={titles}
                    loading={loading}
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected}
                />
            </div>
        </main>
    );
}